import "./Home.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import ValorisezVotreMarque from "./sections/ValorisezVotreMarque";
import TheCaseForInclusion from "./sections/TheCaseForInclusion";
import PilaresAcademicos from "./sections/PilaresAcademicos";
import Farmertestimonials from "./sections/Farmertestimonials";
import TheVitaApproach from "./sections/TheVitaApproach";
import TailoredInvestmentPlans from "./sections/TailoredInvestmentPlans";
import CommonInquiries from "./sections/CommonInquiries";
import ReadyForClarity from "./sections/ReadyForClarity";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <FraternalExcellenceHeader />
      <ValorisezVotreMarque />
      <TheCaseForInclusion />
      <PilaresAcademicos />
      <Farmertestimonials />
      <TheVitaApproach />
      <TailoredInvestmentPlans />
      <CommonInquiries />
      <ReadyForClarity />
      <Footer />
    </div>;
}